import { FC, useCallback, useState } from "react";

import DebugPanelDialog from "./debug-panel-dialog";
import useSecretWord from "../hooks/use-secret-word";
import { DEBUG_PANEL_SECRET_WORD } from "../utils/secret-word";
import { isDebugPanelHost, isDevPortalHost } from "../utils/portal-host";

/**
 * Developer settings, opened by typing "folloadmin" anywhere outside a form
 * field. Never mounted in production.
 *
 * Not Ctrl + the word: browsers keep Ctrl+N (new window) for themselves on
 * Windows and Linux, so the page would never see the last letter.
 */
const DebugPanel: FC = () => {
  const [open, setOpen] = useState(false);
  const { hostname } = window.location;
  const enabled = isDebugPanelHost(hostname);

  const openPanel = useCallback(() => setOpen(true), []);

  useSecretWord(DEBUG_PANEL_SECRET_WORD, openPanel, enabled);

  if (!enabled) {
    return null;
  }

  return (
    <DebugPanelDialog
      open={open}
      onOpenChange={setOpen}
      showApiNamespace={isDevPortalHost(hostname)}
    />
  );
};

export default DebugPanel;
